import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'comma' })
export class AddCommaPipe implements PipeTransform {
  public transform(value: string, end?: boolean): string {
    if (!value) {
      return '';
    }
    if (end) {
      value = value + ', ';
    }

    return value;
  }
}
